export function timeFormate(time, fmcode){
    // fmcode 1:转字符串，2：转数字
    if (fmcode == 1) {
        var vTime = (time + '').split(".")[0];
        var t = 0,
          m = 0,
          s = 0;
        if (vTime > 3600) {
          t = (vTime - vTime % 3600) / 3600;
          vTime = vTime % 3600;
        }

        if (vTime > 60) {
          m = (vTime - vTime % 60) / 60;
          vTime = vTime % 60;
        }

        if (vTime < 60) {
          s = vTime;
        }

        function zeroAdd(stime) {
          if (stime <= 9) {
            return '0' + stime;
          } else {
            return '' + stime
          }
        }

        if (t > 0) {
          return zeroAdd(t) + ":" + zeroAdd(m) + ":" + zeroAdd(s);
        } else {
          return zeroAdd(m) + ":" + zeroAdd(s);
        }

    } else if (fmcode == 2) {

        let stime = time.split(":");
        let nextTime = 0;

        if (stime.length == 3) {
          nextTime = stime[0] * 3600 + stime[1] * 60 + stime[2];
        } else {
          nextTime = parseInt(stime[0]) * 60 + parseInt(stime[1]);
        }

        return nextTime;

    }
}

export function dateFormate(newTime){
        var timeTemp;
        if(newTime){
             timeTemp = new Date(newTime);
        }else{
             timeTemp = new Date();
        }

        var y = timeTemp.getFullYear();
        var m = timeTemp.getMonth() + 1;
        var d = timeTemp.getDate();

        if(m < 10){
            m = '0' + m;
        }

        if(d < 10){
            d = '0' + d;
        }

        return y + '-' + m + '-' + d;
}

export function ismobile(test){
      var u = navigator.userAgent, app = navigator.appVersion;
      if(/AppleWebKit.*Mobile/i.test(navigator.userAgent) || (/MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/.test(navigator.userAgent))){
       if(window.location.href.indexOf("?mobile")<0){
        try{
         if(/iPhone|mac|iPod|iPad/i.test(navigator.userAgent)){
          return 0;
         }else{
          return 1;
         }
        }catch(e){}
       }
      }else if( u.indexOf('iPad') > -1){
          return 0;
      }else{
          return 1;
      }
}

